import React, { useState, useEffect } from "react";
import Navbar from "../../Navbar";
import Sidebar from "../../Sidebar";
import axios from "axios";
import Config from "../../Config";
import Cookies from "js-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../../useAuthhandling';


function Editevel1() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const location = useLocation();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();
  const [service, setService] = useState([]);
  const [formerror, setError] = useState({});

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/category-detail`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    const data = await res.json();
    if (res.status === 200) {
      setService(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setService({ ...service, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.serviceName) {
      errors.serviceName = "service name is required!";
    }

    if (!values.description) {
      errors.description = "Description is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { serviceName, description } = service;
    const ress = validate(service);
    setError(ress);
    if (!ress.serviceName && !ress.description) {
      const formData = new FormData();
      formData.append("categoryName", service.serviceName);
      formData.append("categoryLevel", service.description);

      formData.append("categoryDescription", service.description);
      formData.append("categoryImg", service.serviceImg);
      axios
        .put(
          `${Config.apiurl}/api/v1/crm/service/update-service-info/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200 ) {
            toast.success("Sucessfully Updated Service", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            toast.error("something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
  }, []);
  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Service Edit Table</h4>
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Servicename
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="servicename"
                          name="serviceName"
                          value={service.serviceName}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.serviceName}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Description"
                          name="description"
                          value={service.description}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.description}
                        </label>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (407px * 273px)
                        </label>
                        <br></br>
                        <input
                          type="file"
                          name="serviceImg"
                          onChange={onFileChange}
                        />
                        <img src={service.serviceImg} width="200" alt="" />
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Editevel1;
